class AmbassadorGridFilter {
  constructor(container) {
    this.container = container;
    this.filterButtons = container.querySelectorAll('.ambassador-grid__type');
    this.ambassadorCards = container.querySelectorAll('.ambassador-card');
    
    this.init();
  }

  init() {
    // Add click event listeners to filter buttons
    this.filterButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFilterClick(button);
      });
    });
    
    // Filter by first active button on load
    const activeButton = this.container.querySelector('.ambassador-grid__type.active');
    if (activeButton) {
      this.filterCards(activeButton.dataset.filter);
    }
  }

  handleFilterClick(clickedButton) {
    const filterType = clickedButton.dataset.filter;
    
    // Update active state
    this.updateActiveButton(clickedButton);
    
    // Filter ambassador cards
    this.filterCards(filterType);
  }

  updateActiveButton(activeButton) {
    // Remove active class from all buttons
    this.filterButtons.forEach(button => {
      button.classList.remove('active');
    });
    
    // Add active class to clicked button
    activeButton.classList.add('active');
  }

  filterCards(filterType) {
    this.ambassadorCards.forEach(card => {
      const cardType = card.dataset.type;
      const motionElement = card;
      
      if (cardType === filterType) {
        // Show card with animation
        this.showCard(motionElement);
      } else {
        // Hide card with animation
        this.hideCard(motionElement);
      }
    });
  }

  showCard(element) {
    element.classList.add('active');
  }

  hideCard(element) {
    element.classList.remove('active');
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const ambassadorGrids = document.querySelectorAll('.ambassador-grid');
  
  ambassadorGrids.forEach(grid => {
    new AmbassadorGridFilter(grid);
  });
});

